import React, { Component } from 'react';
import { Table } from 'antd';

class AdminUsersView extends Component {
    render() {
        const columns = [{
            title: 'Company',
            dataIndex: 'company.name',
            key: 'company.name',
        }, {
            title: 'User',
            dataIndex: 'key',
            key: 'key',
        }, {
            title: 'Role',
            dataIndex: 'type',
            key: 'type',
        }];
        return (
            <Table dataSource={this.props.users} columns={columns} />
        );
    }
}

export default AdminUsersView;



// WEBPACK FOOTER //
// ./src/components/views/AdminUsersView.js